/* eslint-disable react-hooks/exhaustive-deps */
import uuid from 'uuid/v4';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HistoryHelper from '@Services/HistoryHelper';
import NavigationHistory from '@Services/NavigationHistory';
import { compose } from 'redux';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import StructureThumbnailContainer from '@Containers/StructureThumbnail';
import values from 'lodash/values';
import { open as openStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';
import { hideGlobalSpinner } from '@Containers/GlobalSpinner/GlobalSpinnerActions';
import { spinnerTypes } from '@Containers/GlobalSpinner/GlobalSpinnerConstants';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import Button from '@Components/Button';
import { isAlertVisible } from '@Pages/Alerts/AlertsUtils';
import { dispatchCreateAlert } from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogActions';
import { recordCountOrResultSizeFromHistoryItem } from '@Containers/PatentFamilyClustering/selectors';
import { historyReducerKey, typeOfHistoryConfirmationDialog, typeOfHistorySaveDialog } from '../Constants';
import { fetchSavedHistory, handleViewSaveModal, handleViewDeleteModal, onDelete, onSaveUnLoad } from '../HistoryAction';
import { capitalizeFirstLetter, todayDateFilter } from '../utils';

function HistorySaved() {
  const { savedHistory, historyTypes, isSavedHistoryLoaded, showSaveModal, showDeleteModal, itemTobeDeleted, isDeleteInProgress } =
    useSelector((state) => state.get(historyReducerKey));
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSavedHistory());
    return () => {
      dispatch(hideGlobalSpinner());
      dispatch(onSaveUnLoad(spinnerTypes.progress));
      dispatch(closeDialog({ id: typeOfHistoryConfirmationDialog }));
      dispatch(closeDialog({ id: typeOfHistorySaveDialog }));
    };
  }, []);
  useEffect(() => {
    if (showDeleteModal) {
      dispatch(
        updateDialog({
          id: typeOfHistoryConfirmationDialog,
          dialogType: typeOfHistoryConfirmationDialog,
          title: 'Delete',
          text: 'Are you sure?',
          submitButtonText: 'Yes',
          dismissButtonText: 'Cancel',
          isCancelButton: true,
          backdrop: false,
          onClose: () => {
            dispatch(handleViewDeleteModal(false));
          },
          onConfirm: () => {
            dispatch(onDelete(itemTobeDeleted));
          },
        })
      );
    } else {
      dispatch(closeDialog({ id: typeOfHistoryConfirmationDialog }));
    }
  }, [showDeleteModal]);
  useEffect(() => {
    if (showSaveModal) {
      dispatch(
        updateDialog({
          id: typeOfHistorySaveDialog,
          dialogType: typeOfHistorySaveDialog,
        })
      );
    } else {
      dispatch(closeDialog({ id: typeOfHistorySaveDialog }));
    }
  }, [showSaveModal]);
  const isTypeSupported = (historyType) => historyTypes && values(historyTypes).indexOf(historyType) !== -1;
  if (!isSavedHistoryLoaded) {
    return (
      <div className="history-page__container">
        <div className="query__group" />
      </div>
    );
  }
  return (
    <div className="history-page__container">
      {savedHistory.length > 0 ? (
        <div className="query__group">
          {savedHistory.map((groupItem, groupItemIndex) => (
            <section key={`savedGroupItem${groupItem.databaseName}`}>
              <span className="history__dbs__name">{groupItem.databaseName}</span>
              {groupItem.items &&
                groupItem.items
                  .sort((x, y) => y.creationTime - x.creationTime)
                  .map((item, index) => (
                    <article
                      key={`historySavedItem${groupItem.databaseName}${item.searchId}`}
                      className={`query__item query__item--saved query__item--${groupItem.databaseName === 'Commercial Substances' ? 'commercialsubstance' : item.context}`}
                      title={`${item.comment}`}>
                      <div className="query__item__row">
                        <header className="query__item__header">
                          <h2 className="query__item__title u-els-font-size-h4">
                            {`${recordCountOrResultSizeFromHistoryItem(item)} ${item.context ? capitalizeFirstLetter(item.context.replace(/"/g, '')) : ''}`}
                          </h2>
                          <time className="query__item__time">{item.userTime && todayDateFilter(item.userTime)}</time>
                        </header>
                        <section className="query__item__content">
                          <h3 className="query__item__title u-els-font-size-h4">{item.searchName}</h3>
                        </section>
                        <footer className="query__item__options">
                          <div className="rx-btn-wrap rx-btn-group--right history-btn-group">
                            <Button
                              name="edit-query"
                              disabled={
                                item.historyType !== historyTypes.QUERY_BUILDER &&
                                !(item.quickSearchItem && item.quickSearchItem.whereClauseImportToken)
                              }
                              buttonConfig={{
                                type: 'link',
                                size: 'sm',
                                label: 'Edit query',
                                e2eName: 'history-saved-edit-query',
                              }}
                              iconConfig={{
                                name: 'duplicate-document',
                                size: 'sm',
                              }}
                              onClick={() => HistoryHelper.copyQuery(item)}
                            />
                            <Button
                              name="delete"
                              buttonConfig={{
                                type: 'link',
                                size: 'sm',
                                label: 'Delete',
                                e2eName: 'history-saved-delete',
                              }}
                              iconConfig={{ name: 'trash', size: 'sm' }}
                              onClick={() => dispatch(handleViewDeleteModal(true, groupItemIndex, index, { ...item }))}
                            />
                            <Button
                              name="rename"
                              disabled={!isTypeSupported(item.historyType)}
                              buttonConfig={{
                                type: 'link',
                                size: 'sm',
                                label: 'Rename',
                                e2eName: 'history-saved-rename',
                              }}
                              iconConfig={{ name: 'save-file', size: 'sm' }}
                              onClick={() => dispatch(handleViewSaveModal(true, false, groupItemIndex, index, { ...item }))}
                            />
                            {isAlertVisible(item) && (
                              <Button
                                name="alert"
                                buttonConfig={{
                                  type: 'link',
                                  size: 'sm',
                                  label: 'Alert',
                                  e2eName: 'history-saved-open-alert',
                                }}
                                iconConfig={{ name: 'notifications', size: 'md' }}
                                onClick={() => dispatchCreateAlert(item)}
                              />
                            )}
                          </div>
                          <Button
                            name="view"
                            disabled={item.resultSize === 0}
                            buttonConfig={{
                              type: 'tertiary',
                              size: 'md',
                              label: 'View',
                              e2eName: 'history-saved-open-view',
                            }}
                            iconConfig={{ name: 'chevron-right' }}
                            onClick={() => NavigationHistory.viewHistory(item)}
                          />
                        </footer>
                      </div>
                      <section className="query__item__content">
                        <div className="query__item__description">
                          <div>
                            <div className="crumb-comment">
                              {item.batchSearch && (
                                <span className="rx-btn rx-btn--small rx-btn--basic_link rx-btn--right pull-right">
                                  <span className="rx-btn-text">
                                    <span className="rx-btn-text-container">Execution details</span>
                                  </span>
                                  <span className="rx-btn-icon">
                                    <i className="ss-navigateright button-icon" />
                                  </span>
                                </span>
                              )}
                              <span>{item.comment}</span>
                            </div>
                            {item.quickSearchItem && item.quickSearchItem.structure && (
                              <Button
                                className="rx-btn rx-btn--small rx-btn--structure"
                                buttonConfig={{
                                  size: 'sm',
                                  className: 'els-btn-structure',
                                  e2eName: 'history-saved-structure',
                                }}
                                onClick={() => {
                                  dispatch(openStructureDialog(uuid(), item.quickSearchItem.structure));
                                }}>
                                <StructureThumbnailContainer
                                  enableThumbnail
                                  structure={item.quickSearchItem.structure}
                                  thumbnailType="history"
                                />
                              </Button>
                            )}
                            {item.structures && item.structures.length > 0 && (
                              <Button
                                className="rx-btn rx-btn--small rx-btn--structure"
                                key={`structure${uuid()}`}
                                buttonConfig={{
                                  size: 'sm',
                                  className: 'els-btn-structure',
                                  e2eName: 'history-saved-structure',
                                }}
                                onClick={() => {
                                  dispatch(openStructureDialog(uuid(), item.structures));
                                }}>
                                <StructureThumbnailContainer
                                  enableThumbnail
                                  structure={item.structure || item.structures[0].structure}
                                  thumbnailType="history"
                                />
                              </Button>
                            )}
                          </div>
                        </div>
                      </section>
                    </article>
                  ))}
            </section>
          ))}
        </div>
      ) : (
        <div className="query__group">No saved searches found...</div>
      )}
      {isDeleteInProgress && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId="history-confirmation-loading" />}
    </div>
  );
}

const EnhancedHistorySaved = compose(withCombinedRouteParams, withRouter)(HistorySaved);
export default EnhancedHistorySaved;
